import { api } from "@/api"

export type UnlinkedRefundsSettings = {
  enableUnlinkedRefunds: boolean
  unlinkedRefundsSingleMaximum: number
  unlinkedRefundsDailyMaximum: number
}

export const updateUnlinkedRefundsSettings =
  async (newValue: {
    isUnlinkedRefundsEnabled: boolean
    unlinkedRefundsSingleMaximum: number | null
    unlinkedRefundsDailyMaximum: number | null
  }) => {
    const { body } =
      await api.patch<UnlinkedRefundsSettings>(
        `/config-unlinked-refunds`,
        {
          body: {
            enableUnlinkedRefunds:
              newValue.isUnlinkedRefundsEnabled,
            unlinkedRefundsSingleMaximum:
              newValue.unlinkedRefundsSingleMaximum,
            unlinkedRefundsDailyMaximum:
              newValue.unlinkedRefundsDailyMaximum,
          },
        }
      )

    return {
      isUnlinkedRefundsEnabled: body.enableUnlinkedRefunds,
      unlinkedRefundsSingleMaximum:
        body.unlinkedRefundsSingleMaximum,
      unlinkedRefundsDailyMaximum:
        body.unlinkedRefundsDailyMaximum,
    }
  }
